import React,{useState} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'react-bootstrap/Dropdown';
import {faEdit, faPaperPlane, faArrowRight, faBell, faCreditCard,faClone} from '@fortawesome/free-solid-svg-icons';
import swal from "sweetalert2";
import { useHistory, Link } from "react-router-dom";
import TopInfosDocument from './DetailButton/TopInfosDocument'
import { DocumentColumDataTableReorganize, DocumentSortAndGroup} from "@gull";
import {column_correspondance_facture,recap_correspondance_facture} from '../../correspondance_facture'

const DetailAndButton = (props) =>{
    const t = useTranslate();
    const history = useHistory();
    const [showColumnOrganize,setShowColumnOrganize]=useState(false)
    const [showLinesOrganize,setShowLinesOrganize]=useState(false)
    const [showSortAndGroup,setShowSortAndGroup]=useState(false)

    // Pour empecher la conversion d'un BL déjà converti
    const blConverted = (props.allInfos.type=='deliveryNote') ? ((Object.keys(props.allInfos.parents_of).length!=0) ? true : false) : false

    const handleClick = (name) =>{
        if(name=='cancel'){
            let totalPayment = +props.allInfos.ttc
            let totalPaid = 0
        
            props.allInfos.facture_paiement_records.map((value,ind)=>{
                totalPaid = totalPaid + +value.montant
            })

            if((+totalPayment == +totalPaid) || totalPaid==0){
                swal
                .fire({
                    title:t('confirmCancelDocument'),
                    icon: "warning",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: t('btnYes'),
                    cancelButtonText: t('btnNo'),
                })
                .then((result) => {
                    if (result.value) {
                        props.cancelInvoice()
                    }
                });
            }else{
                swal.fire(t('mustDeletePaymentBeforeCancel'), "", "warning");
            }
        }else if(name=='validateDeliveryNote'){
            swal
            .fire({
                title:t('confirmValidateDeliveryNote'),
                icon: "warning",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t('btnYes'),
                cancelButtonText: t('btnNo'),
            })
            .then((result) => {
                if (result.value) {
                    props.validateDeliveryNote()
                }
            });
        }else if(name=='convertDeliveryNoteToInvoice'){
            props.convertDeliveryNoteToInvoice()
        }else if(name=='convertToInvoice'){
            props.convertQuotationToInvoice()
        }else if(name=='convertPo'){
            history.push("/invoice/convert-to-purchase-order/"+props.allInfos.id)
        }else if(name=='convertToReturnOrder'){
            history.push("/invoice/convert-to-return-order/"+props.allInfos.id)
        }else if(name=='convertDeliveryNote'){
            history.push("/invoice/convert-to-delivery-note/"+props.allInfos.id)
        }else if(name=='convertToCreditNote'){
            history.push("/invoice/convert-to-credit-note/"+props.allInfos.id)
        }else if(name=='convertToCreditNoteBuy'){
            history.push("/invoice/convert-to-credit-note-buy/"+props.allInfos.id)
        }
        // else if(name=='duplicate'){
        //     props.duplicateDocument()
        // }
        else{
            props.setShowEdit(name)
        }
    }

    return (
        <div>
            <TopInfosDocument 
                allInfos={props.allInfos}
                clientDetail={props.clientDetail}

                id={props.id}
                setId={props.setId}
                setTitleDocument={props.setTitleDocument}
                setItemsBilling={props.setItemsBilling}
                setAllInfos={props.setAllInfos}
                constructionDocument={props.constructionDocument}
                company={props.company}
                moduleFacturation={props.moduleFacturation}
                from={props.from}
                setBrownDocumentModal={(props.setBrownDocumentModal) ? props.setBrownDocumentModal : false}
            />

            <div className='mt-5'>
                <div className="d-flex flex-wrap gap-2">
                    <Dropdown className='me-2'>
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" disabled={props.disabled}>
                            {t('edit')}&nbsp;&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faEdit} />&nbsp;
                        </Dropdown.Toggle>

                        <Dropdown.Menu>

                            {((props.allInfos.type!='creditNote' && props.allInfos.type!='creditNoteBuy' && props.allInfos.type!='billingDeposit') && props.allInfos.cancelled==0) &&
                                <Dropdown.Item onClick={()=>handleClick('cancel')}>{t('cancelDocument',{document: t(props.allInfos.type)})}</Dropdown.Item>
                            }
                            {((props.allInfos.type=='billingDeposit') && props.allInfos.cancelled==0) &&
                                <Dropdown.Item onClick={()=>handleClick('payment')}>{t('btnModifier')+' '+t('depositLabel').toLowerCase()}</Dropdown.Item>
                            }

                            {props.allInfos.type!='billingDeposit' && <Dropdown.Item onClick={()=>handleClick('creationDate')}>{t('createdAt')}</Dropdown.Item>}
                            {((props.allInfos.type=='billing' || props.allInfos.type=='quotation') && props.allInfos.date_validation==null &&props.allInfos.cancelled==0) &&
                                <Dropdown.Item onClick={()=>handleClick('limitpay')}>{props.allInfos.type=='billing' ? t('limitDatePay') : t('limitDateValidity')}</Dropdown.Item>
                            }

                            {(props.allInfos.type!='billingDeposit') && 
                                <Dropdown.Item>
                                    <DocumentColumDataTableReorganize 
                                        columnOrganize={props.columnShow}
                                        setColumnOrganize={props.setColumnShow}
                                        showColumnOrganize={showColumnOrganize}
                                        setShowColumnOrganize={setShowColumnOrganize}
                                        possibilities={column_correspondance_facture}
                                        nameBtn="colonnes"
                                        btnSwitch={true}//pour affiche ou non le btn swith
                                        initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                        notButton={true}
                                        saveBack={'column_pdf'}
                                        id={props.id}
                                        setBrownDocumentModal={(props.setBrownDocumentModal) ? props.setBrownDocumentModal : false}
                                    />
                                </Dropdown.Item>
                            }
                            {(props.allInfos.type!='billingDeposit') && 
                                <Dropdown.Item>
                                    <DocumentColumDataTableReorganize 
                                        columnOrganize={props.recapShow}
                                        setColumnOrganize={props.setRecapShow}
                                        showColumnOrganize={showLinesOrganize}
                                        setShowColumnOrganize={setShowLinesOrganize}
                                        possibilities={recap_correspondance_facture}
                                        nameBtn="lines"
                                        btnSwitch={true}//pour affiche ou non le btn swith
                                        initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                        notButton={true}
                                        saveBack={'recap_pdf'}
                                        id={props.id}
                                        setBrownDocumentModal={(props.setBrownDocumentModal) ? props.setBrownDocumentModal : false}
                                    />
                                </Dropdown.Item>
                            }
                            {(props.allInfos.type!='billingDeposit') && // Bouton tri et regroupement
                                <Dropdown.Item>
                                    <DocumentSortAndGroup 
                                        showSortAndGroup={showSortAndGroup}
                                        setShowSortAndGroup={setShowSortAndGroup}
                                        nameBtn="sortAndGroup"
                                        notButton={true}
                                        id={props.id}
                                        setItemsBilling={props.setItemsBilling}
                                        setAllInfos={props.setAllInfos}
                                        setDatasPdf={props.setDatasPdf}
                                        allInfos={props.allInfos}
                                        setBrownDocumentModal={(props.setBrownDocumentModal) ? props.setBrownDocumentModal : false}
                                    />
                                </Dropdown.Item>
                            }
                            <Dropdown.Item onClick={()=>handleClick('topText')}>{t('topText')}</Dropdown.Item>
                            <Dropdown.Item onClick={()=>handleClick('bottomText')}>{t('bottomText')}</Dropdown.Item>
                            <Dropdown.Item onClick={()=>handleClick('note')}>{t('noteInterne')}</Dropdown.Item>

                            {(props.allInfos.type!='billingDeposit' && props.allInfos.type!='billingBuy' && props.allInfos.type!='creditNoteBuy') && <Dropdown.Item onClick={()=>handleClick('client')}>{t('customer')}</Dropdown.Item>}
                            {(props.allInfos.type=='billing' || props.allInfos.type=='quotation' || props.allInfos.type=='purchaseOrderB2b') &&
                                <Dropdown.Item onClick={()=>handleClick('modePayDefault')}>{t('modePay')}</Dropdown.Item>
                            }
                            
                            {(props.allInfos.type=='billing') &&
                                <div className='me-2'>
                                    <Dropdown.Item onClick={()=>handleClick('saveTemplate')}>{t('saveDocTemplate')}</Dropdown.Item>
                                </div>
                            }                            
                        </Dropdown.Menu>
                    </Dropdown>
                    {((props.allInfos.type=='billing' || props.allInfos.type=='quotation' || props.allInfos.type=='purchaseOrderB2b' || props.allInfos.type=='creditNote' || props.allInfos.type=='billingBuy') && props.allInfos.cancelled==0) &&
                        <Dropdown  className='me-2'>
                            <Dropdown.Toggle variant="success" id="dropdown-basic" disabled={props.disabled}>
                                {t('convert')}&nbsp;&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faArrowRight} />&nbsp;
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {((props.allInfos.type=='quotation') && props.allInfos.cancelled==0) &&
                                    <Dropdown.Item onClick={()=>handleClick('convertPo')}>{t('convertToPo')}</Dropdown.Item>
                                }
                                {((props.allInfos.type=='quotation') && props.allInfos.cancelled==0) &&
                                    <Dropdown.Item onClick={()=>handleClick('convertToInvoice')}>{t('convertToInvoice')}</Dropdown.Item>
                                }
                                {((props.allInfos.type=='purchaseOrderB2b') && props.allInfos.cancelled==0) &&
                                    <Dropdown.Item onClick={()=>handleClick('convertDeliveryNote')}>{t('convertToDeliveryNote')}</Dropdown.Item>
                                }
                                {(props.allInfos.type=='creditNote') &&
                                    <Dropdown.Item onClick={()=>handleClick('convertToReturnOrder')}>{t('convertToReturnOrder')}</Dropdown.Item>
                                }
                                {((props.allInfos.type=='billing') && props.allInfos.cancelled==0) &&
                                    <Dropdown.Item onClick={()=>handleClick('convertToCreditNote')}>{t('convertToCreditNote')}</Dropdown.Item>
                                }
                                {((props.allInfos.type=='billingBuy') && props.allInfos.cancelled==0) &&
                                    <Dropdown.Item onClick={()=>handleClick('convertToCreditNoteBuy')}>{t('convertToCreditNoteBuy')}</Dropdown.Item>
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    {(props.allInfos.type=='deliveryNote'&& props.allInfos.cancelled==0 && props.allInfos.date_validation && !blConverted) &&
                        <Dropdown  className='me-2'>
                            <Dropdown.Toggle variant="success" id="dropdown-basic" disabled={props.disabled}>
                                {t('convert')}&nbsp;&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faArrowRight} />&nbsp;
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={()=>handleClick('convertDeliveryNoteToInvoice')}>{t('convertToInvoice')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    {(props.allInfos.type=='billing' || props.allInfos.type=='quotation' || props.allInfos.type=='purchaseOrderB2b' || props.allInfos.type=='creditNote' || props.allInfos.type=='billingBuy' || props.allInfos.type=='creditNoteBuy') &&
                        <div className='me-2'>
                            <button disabled={props.disabled || props.validIndividualButton.duplicate} className='btn btn-light' onClick={()=>handleClick('duplicate')}>
                                {t('dupliquer')}
                                &nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faClone} />&nbsp;
                            </button>
                        </div>
                    }
                    {((props.allInfos.type=='quotation' || props.allInfos.type=='purchaseOrderB2b') && props.allInfos.cancelled==0) &&
                        <div className='me-2'>
                            <button disabled={props.disabled} className='btn btn-info' onClick={()=>handleClick('payment')}>
                                {t('depositLabel')}&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faCreditCard} />&nbsp;
                            </button>
                        </div>
                    }
                    {/**ok pour sur */}
                    {((props.allInfos.type=='billing' || props.allInfos.type=='billingBuy') && props.allInfos.cancelled==0) &&
                        <div className='me-2'>
                            <button disabled={props.disabled} className='btn btn-danger' onClick={()=>handleClick('payment')}>
                                {(props.allInfos.type=='billing' || props.allInfos.type=='billingBuy') ? t('payment') :  t('btnModifier')+' '+t('depositLabel').toLowerCase()}
                            </button>
                        </div>
                    }
                    {(props.allInfos.type=='deliveryNote' && props.allInfos.cancelled==0 && props.allInfos.date_validation==null) &&
                        <div className='me-2'>
                            <button disabled={props.disbaled} className='btn btn-danger' onClick={()=>handleClick('validateDeliveryNote')}>{t('validateDeliveryNote')}</button>
                        </div>
                    }
                    <div className='me-2'>
                        <button disabled={props.disabled} className='btn btn-dark' onClick={()=>handleClick('alertDoc')}>{(props.allInfos.alert_date) ? t('editReminderDoc') : t('createReminderFromDoc')}&nbsp;&nbsp;<FontAwesomeIcon icon={faBell} /></button>
                    </div>
                    <div>
                        <button className='btn btn-warning' onClick={()=>handleClick('sendEmail')}>{t('sendDocEmail')}&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faPaperPlane} />&nbsp;</button>
                    </div>
                    {/**end */}
                </div>
            </div>
            <div className="mt-3">
                <p>
                    {t('mailSent')}: {(props.allInfos.mail_sent) ? <><span className="text-success">Oui</span><br/></> : <><span className="text-danger">Non</span><br/></>}
                    {t('mailOpened')}: {(props.allInfos.mail_opened) ? <><span className="text-success">Oui</span><br/></> : <><span className="text-danger">Non</span><br/></>}
                </p>
            </div>
        </div>
    )
};

export default DetailAndButton;